import React, { useState, useEffect, useRef } from "react";
import "./styles.scss";
import Table from "@mui/material/Table";
import moment from "moment";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useAuth0 } from "@auth0/auth0-react";
import { uploadFile, downloadFile } from "../../Auth/Presigned";
import { DateFormetContext } from "../../../app/App.js";
import { useSelector } from "react-redux";
import { CheckFloatValue } from "../../../utils/functions";
import thousands from "thousands";
import { toastr } from "react-redux-toastr";
import {
  Col,
  NoData,
  Row,
  RowBody,
  RowCol,
  Tbody,
  Thead,
  TitleBody,
} from "./Theme";
import { map } from "lodash";

function createData(date, chargesDetails, amount, paymentMethod, total) {
  return { date, chargesDetails, amount, paymentMethod, total };
}

const TaxReportDocoment = ({
  data,
  downloadPDF,
  sharePDF,
  setFileData,
  setFile,
}) => {
  const dateFormet = React.useContext(DateFormetContext);
  const { getAccessTokenSilently } = useAuth0();
  let totalAmount = 0;
  let totalElgAmount = 0;
  for (let i = 0; i < data?.transaction.length; i++) {
    if (data?.transaction) {
      totalElgAmount += data?.transaction[i].eligible_amount;
    }
  }
  const [loading, setLoading] = useState(false);
  for (let i = 0; i < data?.transaction.length; i++) {
    if (data?.transaction) {
      totalAmount += data?.transaction[i].contribution_amount;
    }
  }

  const getCommaSeperatedValue = (num) => {
    return CheckFloatValue(parseFloat(num))
      ?.toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const LogoImage = useSelector((state) => state.homeReducer.headerLogo);
  const Image = localStorage?.getItem("Base64");

  const inputRef = useRef(null);
  const printDocument = async () => {
    const token = await getAccessTokenSilently();
    if (downloadPDF) {
      html2canvas(inputRef.current, {
        scrollY: -window.scrollY,
        scrollX: -window.scrollX,
      })
        .then((canvas) => {
          const pdf = new jsPDF();
          let width = 200;
          let height = 0;
          const imgData = canvas.toDataURL("image/png");
          pdf.addImage(imgData, "PNG", 2, 5, width, height);
          pdf.save("tax_report.pdf");
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
        });
    } else if (sharePDF) {
      html2canvas(inputRef.current)
        .then(async (canvas) => {
          let width = -105;
          let height = -100;
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jsPDF();
          pdf.addImage(imgData, "PNG", 10, 10, width, height);
          var out = pdf.output("blob");
          setFileData([
            { name: "taxReportDoc", size: out.size, type: out.type },
          ]);
          setFile([imgData]);

          const convertedfile = new File([out], {
            type: "application/pdf",
            name: "taxReportDoc",
          });

          var splitedImgData = imgData.split(",")[1];
          var binary_string = window.atob(splitedImgData);
          var len = binary_string.length;
          var bytes = new Uint8Array(len);
          for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
          }
          if (imgData) {
            setLoading(true);
            let newURL = await uploadFile(bytes.buffer, convertedfile, token);

            let downloadLink = await downloadFile(newURL.fileName, token);
            let downloadURL = downloadLink.link;
            window.location = `mailto:${
              data?.account_details?.email ?? ""
            }?subject=Tax Report ${
              data?.tax_id
            }&body= Here is the link to download document - ${encodeURIComponent(
              downloadURL
            )}`;
            setLoading(false);
          }
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
        });
    }
  };
  useEffect(() => {
    printDocument();
  }, []);

  let address = {};
  if (data?.account_details?.addresses) {
    for (var i = 0; i < data.account_details.addresses.length; i++) {
      if (data.account_details.addresses[i].billing) {
        address = {
          city: data.account_details.addresses[i].city,
          state: data.account_details.addresses[i].state,
          zip_code: data.account_details.addresses[i].zip_code,
          formattedAddress: `${
            data.account_details.addresses[i].location?.formattedAddress?.split(
              ","
            )[0]
          } ${
            data.account_details.addresses[i].addressLine2
              ? data.account_details.addresses[i].addressLine2
              : ""
          } `,
        };
      }
    }
  }

  const billingAddress = data?.account_details?.addresses?.find(
    (el) => el?.billing
  );

  return (
    <>
      {loading == true ? <p>Loading ...</p> : ""}
      <div className="pdf-doco py-5 d-flex flex-column justify-content-between">
        <div className="m-5" ref={inputRef}>
          <div className="px-5" style={{ borderBottom: "1px solid" }}>
            <div
              style={{ paddingBottom: 35 }}
              className=" d-flex justify-content-between  "
            >
              <div className="doco-h-logo" style={{ width: 148 }}>
                <img
                  src={Image ?? LogoImage}
                  style={{ width: "100%" }}
                  alt="logo"
                />
              </div>
              <TitleBody className="doco-h-details ">
                {data?.organization?.orgName ? (
                  <span>{data?.organization?.orgName}</span>
                ) : null}
                {data?.organization?.contactInfo?.address ? (
                  <span>{data?.organization?.contactInfo?.address}</span>
                ) : null}
                {data?.organization?.contactInfo?.email ? (
                  <span>{data?.organization?.contactInfo?.email}</span>
                ) : null}
                {data?.organization?.shul_website ? (
                  <span>{data?.organization?.shul_website}</span>
                ) : null}
              </TitleBody>
            </div>

            <div style={{ marginBottom: "32px" }} className="doco-body">
              <div className="doco-body-h mb-10">
                <div className=" d-flex justify-content-between align-items-end ">
                  <TitleBody className="doco-h-details align-items-start ">
                    <span
                      className="font"
                      style={{
                        color: "#002E5C",
                        fontSize: "20px",
                        fontWeight: 600,
                      }}
                    >
                      Tax Report
                    </span>
                    <span style={{ fontWeight: 600 }}>{data?.name}</span>
                    <span>{`${billingAddress?.location?.formattedAddress} ${billingAddress?.addressLine2} `}</span>
                    <span>
                      {`${billingAddress?.city}, ${billingAddress?.state} ${billingAddress?.zip_code} `}{" "}
                    </span>
                    <span>{`Payments made from:${moment(
                      data?.date?.start
                    ).format("MM/DD/YYYY")} to: ${moment(
                      data?.date?.end
                    ).format("MM/DD/YYYY")} `}</span>
                  </TitleBody>

                  <TitleBody className="doco-h-details align-items-start ">
                    <span>
                      {`Date: ${moment(data?.createdAt).format("MM/DD/YYYY")}`}
                    </span>
                    <span>{`Invoice ID: ${data?.tax_id}`}</span>
                    <span>Page: 1 of 1</span>
                  </TitleBody>
                </div>
              </div>

              <div className="overflow-auto w-100">
                <Table>
                  <Thead nums={3}>
                    <>
                      <Col>DATE</Col>
                      <Col> LEDGER</Col>

                      <Col className="justify-content-center">PAYMENTS</Col>
                    </>
                  </Thead>
                  <Tbody>
                    {data.transaction.length ? (
                      map(data.transaction, (row, index) => {
                        return (
                          <RowBody>
                            <Row key={index} nums={3}>
                              <RowCol>
                                {" "}
                                {moment(row.date)
                                  .utcOffset("+0100")
                                  .format("MMMM Do, YYYY")}
                              </RowCol>

                              <RowCol style={{ fontWeight: 600 }}>
                                {row.Ledger.name ? row.Ledger.name : ""}
                              </RowCol>
                              <RowCol className="justify-content-center">
                                {" "}
                                ${" "}
                                {thousands(
                                  (+row.contribution_amount).toFixed(2)
                                )}
                              </RowCol>
                            </Row>
                          </RowBody>
                        );
                      })
                    ) : (
                      <NoData>No Data</NoData>
                    )}
                    <Thead nums={3}>
                      <>
                        <Col></Col>
                        <Col></Col>
                        <Col className="justify-content-center">
                          TOTAL PAYMENTS
                        </Col>
                      </>
                    </Thead>
                    <RowBody style={{ marginTop: 14 }} nums={3}>
                      <RowCol></RowCol>
                      <RowCol></RowCol>
                      <RowCol className="justify-content-center">
                        $ {thousands((+totalAmount).toFixed(2))}
                      </RowCol>
                    </RowBody>
                  </Tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
        <div className=" d-flex justify-content-center flex-column align-items-center pt-4">
          <p style={{ width: "68%", textAlign: "center" }}>
            YOUR DONATION MAY BE TAX-DEDUCTIBLE. Except as noted above, no goods
            or services were provided in whole or in part for this contribution
            other than intangible benfits. Federal ID No. 23-6005909
          </p>

          <p style={{ marginTop: 35 }}>
            {`Congregation Beth Or Statement ${moment(data?.createdAt).format(
              "MM/DD/YYYY"
            )}, Page 1 of 1`}
          </p>
        </div>
      </div>
    </>
  );
};
export default TaxReportDocoment;
